import script from "./EaseOfMovement.vue?vue&type=script&lang=js"
export * from "./EaseOfMovement.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__